/**
 * Generato automaticamente.
 * framework-cfg-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { ModalitaTrasmissioneDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene l'elenco delle modalita trasmissioni ordinate per codice
 * @summary Elenco Modalita Trasmissioni
 */
export const getModalitaTrasmissioni = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ModalitaTrasmissioneDTO[]>(
    {
      url: `/framework-cfg-procedimenti/modalita-trasmissioni`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetModalitaTrasmissioniQueryKey = () =>
  [`/framework-cfg-procedimenti/modalita-trasmissioni`] as const;

export const getGetModalitaTrasmissioniQueryOptions = <
  TData = Awaited<ReturnType<typeof getModalitaTrasmissioni>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getModalitaTrasmissioni>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getModalitaTrasmissioni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetModalitaTrasmissioniQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getModalitaTrasmissioni>>
  > = ({ signal }) => getModalitaTrasmissioni(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetModalitaTrasmissioniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModalitaTrasmissioni>>
>;
export type GetModalitaTrasmissioniQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Modalita Trasmissioni
 */
export const useGetModalitaTrasmissioni = <
  TData = Awaited<ReturnType<typeof getModalitaTrasmissioni>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getModalitaTrasmissioni>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetModalitaTrasmissioniQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
